export interface Line {
  value: string;
  start: number;
  end: number;
}

export function isWhitespace(str: string) {
  // Uses "@babel/plugin-proposal-unicode-property-regex"
  return /\p{Separator}/u.test(str);
}

function isAnyLanguageLetter(str: string) {
  // Uses "@babel/plugin-proposal-unicode-property-regex"
  return /\p{Letter}/u.test(str);
}

function isChinese(str: string) {
  const regex =
    /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
  return regex.test(str);
}

export function isWordChar(text: string, position: number) {
  const code = text.charCodeAt(position);

  return (
    !isChinese(text.charAt(position)) &&
    ((code > 47 && code < 58) || // numeric (0-9)
      (code > 64 && code < 91) || // upper alpha (A-Z)
      (code > 96 && code < 123) || // lower alpha (a-z)
      isAnyLanguageLetter(text.charAt(position))) // foreign languages
  );
}
